import { Component, OnInit } from '@angular/core';
import { LanguageUtilService } from 'src/app/services/language-util.service';
import { PublicResourcesService } from 'src/app/services/resources.service';
import { Commons } from '../../utils/commons';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  imports: [RouterLink, TranslocoPipe]
})
export class AboutUsComponent implements OnInit {

  privacyPolicyPath: string = Commons.PATH_TERMS + '/' + Commons.TERM_CODES[0].code
  termConditionsPath: string = Commons.PATH_TERMS + '/' + Commons.TERM_CODES[1].code
  termSalesPath: string = Commons.PATH_TERMS + '/' + Commons.TERM_CODES[2].code
  cookiePolicyPath: string = Commons.PATH_TERMS + '/' + Commons.TERM_CODES[3].code

  aboutTitle: string = ''
  aboutContent: string = ''

  constructor(
    private service: PublicResourcesService,
    private langService: LanguageUtilService
  ) { }

  ngOnInit(): void {
    this.service.getAboutInfo().subscribe(
      {
        next: async (v) => {
          for (let item of v) {
            if (item.lang === this.langService.getLangActive()) {
              this.aboutTitle = item.title
              this.aboutContent = item.content[0]
            }
          }
        },
        error: (e) => { },
        complete: () => { }
      }
    )
  }

}
